const TYPE_CODE_TO_LABEL = {
  HANG_HOA: 'HÀNG HÓA',
  DICH_VU: 'DỊCH VỤ',
  GHI_CHU: 'GHI CHÚ',
  CHIET_KHAU: 'CHIẾT KHẤU',
};

const TYPE_LABEL_TO_CODE = {
  'HÀNG HÓA': 'HANG_HOA',
  'DỊCH VỤ': 'DICH_VU',
  'GHI CHÚ': 'GHI_CHU',
  'CHIẾT KHẤU': 'CHIET_KHAU',
};

export function mapTypeCodeToLabel(type) {
  const key = String(type || '').trim().toUpperCase();
  return TYPE_CODE_TO_LABEL[key] || TYPE_CODE_TO_LABEL.HANG_HOA;
}

export function extractListAndTotal(res) {
  if (Array.isArray(res)) {
    return { list: res, total: res.length };
  }
  if (res && Array.isArray(res.results)) {
    return {
      list: res.results,
      total: Number(res.count != null ? res.count : res.results.length),
    };
  }
  if (res && Array.isArray(res.data)) {
    return {
      list: res.data,
      total: Number(
        res.count != null
          ? res.count
          : (res.page_info && res.page_info.total != null ? res.page_info.total : res.data.length),
      ),
    };
  }
  return { list: [], total: 0 };
}

export function extractList(res) {
  return extractListAndTotal(res).list;
}

export function normalizeProduct(item) {
  const typeCode = item && item.type ? String(item.type).trim().toUpperCase() : 'HANG_HOA';
  return {
    ...item,
    categoryObj: item && item.category_obj
      ? item.category_obj
      : (item && item.category && typeof item.category === 'object' ? item.category : null),
    categoryId: item && item.category && item.category.id != null
      ? item.category.id
      : (item && item.category_obj && item.category_obj.id != null
        ? item.category_obj.id
        : (item && item.category_id != null ? item.category_id : null)),
    category: item && item.category && item.category.name
      ? item.category.name
      : (item && item.category_obj && item.category_obj.name
        ? item.category_obj.name
        : (item && item.category ? item.category : '')),
    type: typeCode,
    typeLabel: mapTypeCodeToLabel(typeCode),
    taxRate: item && item.rate != null ? item.rate : item ? item.taxRate : null,
  };
}

export function buildProductPayload(formPayload) {
  const typeCode = formPayload.type
    ? String(formPayload.type).trim().toUpperCase()
    : TYPE_LABEL_TO_CODE['HÀNG HÓA'];
  const data = {
    name: formPayload.name,
    unit: formPayload.unit,
    price: formPayload.price || 0,
    rate: formPayload.taxRate != null ? formPayload.taxRate : 0,
    type: typeCode,
  };
  return data;
}

export function buildProductPayloadFromInvoiceLine(line) {
  const data = {
    name: line.name,
    unit: line.unit || '',
    price: Number(line.price) || 0,
    rate: line.rate === 'KHAC' ? (Number(line.custom_tax_rate) || 0) : (Number(line.rate) || 0),
    type: line.type || 'HANG_HOA',
    category: line.category_id || undefined,
  };
  if (data.category == null) delete data.category;
  return data;
}



// WEBPACK FOOTER //
// ./src/services/productService.js